var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.285 10.4786C17.2954 10.4696 17.3054 10.4602 17.3153 10.4503C17.3676 10.398 17.4087 10.3388 17.4385 10.2755C17.5503 10.043 17.5098 9.75557 17.317 9.56279C17.3004 9.54621 17.2832 9.53076 17.2653 9.51644L12.4539 4.70507C12.2098 4.461 11.8141 4.46099 11.57 4.70507C11.3259 4.94915 11.3259 5.34488 11.57 5.58896L15.3692 9.38812L3.24417 9.38812C2.899 9.38812 2.61917 9.66794 2.61917 10.0131C2.61917 10.3583 2.899 10.6381 3.24417 10.6381L15.3578 10.6381L11.5718 14.4241C11.3277 14.6682 11.3277 15.064 11.5718 15.308C11.8158 15.5521 12.2116 15.5521 12.4556 15.308L17.285 10.4786Z",
    fill: "#0C0C0C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightBlack);
export default __webpack_public_path__ + "static/media/ic_arrow_right_black.90ffc1e45a0ab620740c98b6c83581e2.svg";
export { ForwardRef as ReactComponent };